<template>
  <div class="member-classes-courses" v-if="courses.length > 0">
    <div class="member-classes-course" v-for="course in courses" :key="course.course_basis_id">
      <div style="display: flex">
        <img class="member-classes-course-cover" :src="course.cover_img" />
        <div class="member-classes-course-main">
          <div>
            <div class="member-classes-course-title bold6">
              {{ course.course_title }}
            </div>
            <div class="member-classes-course-info">
              <span>共{{ course.section_num }}课时</span>
              <template v-if="course.start_play_date">
                <span class="member-classes-course-line">|</span>
                <span>
                  {{ course.start_play_date | tsFormatDate }}-{{
                    course.end_play_date | tsFormatDate
                  }}
                </span>
              </template>
            </div>
          </div>
          <div class="member-classes-course-teachers">
            <template v-for="(tea, teaIndex) in course.teachers">
              <div
                v-if="teaIndex < 5"
                class="member-classes-course-teacher"
                :class="{ 'member-classes-course-teacher_more': teaIndex == 4 }"
                :key="teaIndex"
                :tip="'共' + course.teachers.length + '位讲师'"
              >
                <img class="member-classes-course-teacher_avatar" :src="tea.avatar" />
                <div class="member-classes-course-teacher_name eps">
                  {{ tea.teacher_name }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
      <template v-if="expand[course.course_basis_id]">
        <div
          v-if="course.display_style == 0"
          class="member-classes-course-periods"
          :class="{
            'member-classes-course-periods_empty': course.periods.length == 0,
          }"
        >
          <MemberClassesPeriod
            class="member-classes-course-period"
            v-for="period in course.periods"
            :key="period.id"
            :period="period"
            :course="course"
            @leave="onLeave(course, period)"
          ></MemberClassesPeriod>
          <EmptyNew v-if="course.periods.length == 0" title="暂无课时"></EmptyNew>
        </div>
        <div
          class="member-classes-course-chapters"
          :class="{
            'member-classes-course-chapters_empty': course.chapter.length == 0,
          }"
          v-else
        >
          <div v-for="chapter in course.chapter" :key="chapter.id">
            <div class="member-classes-course-chapter" @click.stop="onChapterClick(chapter)">
              <span>{{ chapter.title }}</span>
              <img
                v-if="expandChapter == chapter.id"
                class="member-classes-course-chapter_icon"
                src="@/assets/images/classes/arrow-up@2x.png"
              />
              <img
                v-else
                class="member-classes-course-chapter_icon"
                src="@/assets/images/classes/arrow-down@2x.png"
              />
            </div>
            <div
              v-if="expandChapter == chapter.id"
              class="member-classes-course-periods member-classes-course-chapter_periods"
            >
              <MemberClassesPeriod
                class="member-classes-course-period"
                v-for="period in chapter.child"
                :key="period.id"
                :period="period"
                :course="course"
                @leave="onLeave(course, period)"
              ></MemberClassesPeriod>
            </div>
          </div>
          <EmptyNew v-if="course.chapter.length == 0" title="暂无课时"></EmptyNew>
        </div>
      </template>
      <!-- <div class="member-classes-course-type">
        {{ course.course_type | enum("CourseType") }}
      </div> -->
      <div
        class="member-classes-course-btn"
        :class="{
          'member-classes-course-btn_expand': expand[course.course_basis_id],
        }"
        @click.stop="expand[course.course_basis_id] = !expand[course.course_basis_id]"
      >
        课程大纲
      </div>
    </div>
    <LeaveModal
      :show-modal.sync="showModal"
      :onLeaveSubmit="onLeaveSubmit"
      :period="leave.period"
    />
  </div>
  <EmptyNew v-else title="暂无课程"></EmptyNew>
</template>
<script>
import MemberClassesPeriod from './MemberClassesPeriod.vue';
import EmptyNew from '@/components/EmptyNew.vue';
import LeaveModal from './LeaveModal';

export default {
  name: 'MemberClassesCourse',
  components: { MemberClassesPeriod, EmptyNew, LeaveModal },
  data() {
    return {
      id: this.$route.params.id,
      courses: [],
      showModal: false,
      expand: {},
      leave: {
        course: {},
        period: {},
      },
      expandChapter: 0,
    };
  },
  async created() {
    await this.getCourses();
    let expand = {};
    this.courses.forEach((c) => {
      expand[c.course_basis_id] = false;
    });
    this.expand = expand;
  },
  methods: {
    async getCourses() {
      this.courses = await this.$http.get('/api/app/user/classCourse/' + this.id);
    },
    onLeave(course, period) {
      this.leave.course = course;
      this.leave.period = period;
      this.showModal = true;
    },
    async onLeaveSubmit(leaveInfo) {
      await this.$http.post('/api/app/leave', {
        leave_cause: leaveInfo.content,
        class_id: this.id,
        course_id: this.leave.course.course_basis_id,
        course_periods_id: this.leave.period.period_id,
        uid: this.$store.state.user_info.id,
      });
      await this.getCourses();
    },
    onChapterClick(chapter) {
      this.expandChapter = this.expandChapter == chapter.id ? 0 : chapter.id;
    },
  },
};
</script>
<style lang="scss" scoped>
.member-classes-courses {
  padding: 0 24px 32px 24px;
  background: white;
  border-radius: 4px;
}
.member-classes-course {
  padding: 24px 20px;
  position: relative;
  background: #f7f7f7;
  border-radius: 4px;
  margin-top: 24px;
}
.member-classes-course-cover {
  width: 210px;
  height: 140px;
  margin-right: 24px;
}
.member-classes-course-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.member-classes-course-title {
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Semibold;
  line-height: 22px;
  margin-bottom: 6px;
}
.member-classes-course-info {
  color: #999999;
}
.member-classes-course-line {
  margin: 0 10px;
}
.member-classes-course-type {
  position: absolute;
  background: rgba($color: #000000, $alpha: 0.5);
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 13px;
  line-height: 20px;
  color: white;
  right: 930px;
  top: 132px;
}
.member-classes-course-btn {
  position: absolute;
  right: 24px;
  top: 120px;
  width: 109px;
  height: 36px;
  background: #ffffff;
  border: 1px solid #bfbfbf;
  border-radius: 5px;
  line-height: 34px;
  box-sizing: border-box;
  padding-left: 16px;
  background-position: 78px center;
  background-repeat: no-repeat;
  background-size: 15px 8px;
  background-image: url('~@/assets/images/classes/arrow-down@2x.png');
  cursor: pointer;
}
.member-classes-course-btn_expand {
  background-image: url('~@/assets/images/classes/arrow-up@2x.png');
}
.member-classes-course-teachers {
  display: flex;
}
.member-classes-course-teacher {
  max-width: 56px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 30px;
}
.member-classes-course-teacher_avatar {
  width: 32px;
  height: 32px;
  border: 1px solid #e6e6e6;
  border-radius: 50%;
  box-sizing: border-box;
  display: block;
  margin-bottom: 2px;
}
.member-classes-course-teacher_name {
  color: #999999;
  width: 100%;
}
.member-classes-course-teacher_more {
  position: relative;
  &::after {
    content: attr(tip);
    position: absolute;
    white-space: nowrap;
    padding: 2px 8px;
    background: rgba($color: $primary-color, $alpha: 0.1);
    color: $primary-color;
    border-radius: 12px;
    border-bottom-left-radius: 0;
    left: 50%;
    top: -4px;
    margin-left: 20px;
  }
}
.member-classes-course-periods {
  padding: 34px 24px 32px 32px;
  background: white;
  border-radius: 4px;
  margin-top: 25px;
}
.member-classes-course-periods_empty {
  padding-top: 50px;
}
.member-classes-course-chapters {
  background: white;
  padding: 16px 24px 20px 24px;
  margin-top: 25px;
  border-radius: 4px;
}
.member-classes-course-chapters_empty {
  padding-top: 50px;
}
.member-classes-course-chapter {
  padding: 18px 8px 18px 9px;
  border-bottom: 1px solid #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
.member-classes-course-chapter_periods {
  margin-top: 0;
  padding: 32px 0 0 8px;
}
.member-classes-course-chapter_icon {
  width: 15px;
}
.member-classes-dialog_leave {
  ::v-deep {
    .el-button {
      padding: 10px 19px;
    }
    .el-dialog__headerbtn {
      display: none;
    }
    .el-dialog__header,
    .el-dialog__body,
    .el-dialog__footer {
      padding: 0;
    }
    .el-dialog {
      padding: 16px 24px 24px 24px;
    }
    .el-textarea__inner {
      height: 160px;
    }
    .el-textarea {
      margin: 16px 0 8px 0;
    }
  }
  .member-classes-dialog_content {
    margin-bottom: 24px;
  }
  .member-classes-dialog_tip {
    margin-bottom: 16px;
  }
}
</style>
